import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_10 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_11 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_12 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "My Tasks")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
              _createTextVNode(" All Tasks "),
              _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" })
            ], -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Day </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Week </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Month </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Year </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[20] || (_cache[20] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ]),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Project Name "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Deadline "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Status ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/project-management/project-overview",
                  class: "font-medium transition-all hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Web Development ")
                  ])),
                  _: 1
                })
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " 10 Jan 2024 ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Completed ")
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: "/project-management/project-overview",
                  class: "font-medium transition-all hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" UX/UI Design ")
                  ])),
                  _: 1
                })
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " 05 Feb 2024 ", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-success-50 dark:bg-[#15203c] text-success-500 rounded-sm font-medium text-xs" }, " In Progress ")
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_11, [
                _createVNode(_component_RouterLink, {
                  to: "/project-management/project-overview",
                  class: "font-medium transition-all hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode(" React Development ")
                  ])),
                  _: 1
                })
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " 28 Mar 2024 ", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " Cancelled ")
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_12, [
                _createVNode(_component_RouterLink, {
                  to: "/project-management/project-overview",
                  class: "font-medium transition-all hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode(" Python Research ")
                  ])),
                  _: 1
                })
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " 09 Mar 2024 ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-warning-50 dark:bg-[#15203c] text-warning-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1))
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "4",
        total: "36",
        class: "px-[20px] md:px-[25px]"
      })
    ])
  ]))
}